export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'cnt',
        sortField: 'cnt',
        type: 'number',
        callback: 'number',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true
    },
    {
        name: 'ws',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'superwsk',
        sortField: 'superwsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'kei',
        sortField: 'kei',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
        engine: "yandex",
        link: "//help.keys.so/faq#hfaq-post-1953",
    },
    {
        name: 'wizardscount',
        sortField: 'wizardscount',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true
    },
    {
        name: 'wizards',
        type: 'wizards',
        useInFilter: true,
        visible: false
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'avbid',
        sortField: 'avbid',
        type: 'number',
        callback: 'currency',
        dataClass: 'ral avbid',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'serpf',
        sortField: 'serp',
        type: 'string',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: false,
    },
    {
        name: 'isgeo',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: '__component:key-meta-data',
        dataClass: 'key-meta-data',
        useInFilter: false,
    },

]
